// Single place for the frontend's log policy. Today errors go to console.error;
// production log routing (telemetry sink, sampling, etc.) can live here later
// without touching call sites.
export const logger = {
  error: (...args) => console.error(...args),
};
